// extracted by mini-css-extract-plugin
module.exports = {"container":"ThankYouPage_container__tsl6o","containerWithQuiz":"ThankYouPage_containerWithQuiz__qGh8m","withdrawOrderInfo":"ThankYouPage_withdrawOrderInfo__iuuZ5"};